export * from './app.module';
export * from './directives';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/brmasker4/dist/index.js
// module id = ../../../../brmasker4/dist/index.js
// module chunks = vendor